import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from '@mui/material';
import transformToUpperCase from '../helpers/transformToUpperCase';


export const RoleSelector = ({roles, selectedRole, onChangeRole}) => (
    <FormControl sx={{mt: 2, mb: 1}}>
        <FormLabel id="row-radio-buttons-group-label"></FormLabel>
        <RadioGroup
            row
            aria-labelledby="row-radio-buttons-group-label"
            defaultValue={selectedRole}
            value={selectedRole}
            name="distRoles"
            onChange={(e, value) => onChangeRole(value)}
        >
            {roles.map(role =>
                <FormControlLabel
                    key={role}
                    value={role}
                    control={<Radio/>}
                    label={transformToUpperCase(role)}
                />
            )}
        </RadioGroup>
    </FormControl>
);
